import React from 'react';
import { FadeIn } from './FadeIn';
export function MechanismSection() {
  return <section className="bg-brand-navy text-white py-24 px-6 relative" data-id="element-129">
      <div className="absolute top-0 left-0 w-full h-1 bg-brand-teal" data-id="element-130"></div>
      <div className="max-w-3xl mx-auto text-center" data-id="element-131">
        <FadeIn data-id="element-132">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white" data-id="element-133">
            The <span className="text-brand-teal" data-id="element-134">"Reverse-Scroll"</span> Method
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-135">
          <p className="text-lg md:text-2xl leading-relaxed text-gray-200" data-id="element-136">
            Instead of fighting the phone, we weaponize it. This system teaches
            your teen to stop <em data-id="element-137">consuming</em> content and start{' '}
            <strong data-id="element-138">auditing</strong> it.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-139">
          <p className="text-lg md:text-xl leading-relaxed text-gray-300 mt-6" data-id="element-140">
            They will learn to spot "Revenue Leaks" in local businesses—empty
            Instagram pages, unanswered customer comments, and blurry photos—and
            offer a simple, high-value fix that takes them minutes, but saves
            the business owner hours.
          </p>
        </FadeIn>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-brand-teal" data-id="element-141"></div>
    </section>;
}